module.exports = __webpack_public_path__ + "img/zs1.81884211.jpg";